<template>
  <div id="app">
    <!--<div v-if="backButtonStatus" class="goBackButton" @click="goBackClick"><a class="backico"></a></div>-->
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      backButtonStatus: false
    }
  },
  watch: {
    '$route': function () {
      switch (location.pathname) {
        case '/': this.backButtonStatus = false; document.body.style.backgroundColor = '#ffffff'; break
        case '/login': this.backButtonStatus = false; document.body.style.backgroundColor = '#ffffff'; break
        case '/asstsHistroy': document.body.style.backgroundColor = '#0A274A'; this.backButtonStatus = true; break
        default: document.body.style.backgroundColor = '#ffffff'; this.backButtonStatus = true; break
      }
    }
  },
  created: function () {
    // switch (location.pathname) {
    //   case '/': this.backButtonStatus = false; document.body.style.backgroundColor = '#ffffff'; break
    //   case '/login': this.backButtonStatus = false; document.body.style.backgroundColor = '#ffffff'; break
    //   case '/asstsHistroy': document.body.style.backgroundColor = '#0A274A'; this.backButtonStatus = true; break
    //   default: document.body.style.backgroundColor = '#ffffff'; this.backButtonStatus = true; break
    // }
  },
  methods: {
    goBackClick: function () {
      switch (location.pathname) {
        case '/fbeePayHistrony':
          this.$router.push({path: '/userInfo'})
          break
        case '/userInfo':
          this.$router.push({path: '/'})
          break
        case '/share':
          this.$router.push({path: '/'})
          break
        default:
          history.go(-1)
          break
      }
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100%;
  /*overflow: hidden;*/
}
.goBackButton{
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.backico{
  display: block;
  background-image: url("/static/gobackwhite.png");
  height: 0.4rem;
  width: 0.24rem;
  background-size: 100%;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue